/* Ok, But What If — theme scripts */
(function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.querySelector('.nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', nav.classList.contains('open'));
    });
  }

  // Countdown timers — any element with data-countdown="YYYY-MM-DDTHH:MM:SS"
  function pad(n) { return String(n).padStart(2, '0'); }
  document.querySelectorAll('[data-countdown]').forEach(function (root) {
    var target = new Date(root.getAttribute('data-countdown')).getTime();
    var elD = root.querySelector('[data-d]');
    var elH = root.querySelector('[data-h]');
    var elM = root.querySelector('[data-m]');
    var elS = root.querySelector('[data-s]');
    if (isNaN(target)) return;
    function tick() {
      var diff = target - Date.now();
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (elD) elD.textContent = d;
      if (elH) elH.textContent = pad(h);
      if (elM) elM.textContent = pad(m);
      if (elS) elS.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });
})();
